
<app-header *ngIf="isAuthenticated"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="isAuthenticated"></app-footer>